export default __webpack_public_path__ + "static/media/ubiforecast-summary.24ac21ad.png";